module.exports = __webpack_public_path__ + "static/media/25.81656c40.png";